export default {
  async mounted() {
    this.checkOperatedDate()
  },

  methods: {
    async checkOperatedDate() {
      const valid = await this.$store.dispatch('enrollment/validateOperatedTime')
      if (valid) this.sessionTimeout()
      else this.updateLastOperatedDate()
    },
    sessionTimeout() {
      this.$toasted.global.error({ message: 'セッションタイムアウトが発生しました。もう一度やり直してください。' })
      this.$store.commit('enrollment/initialize', {})
      this.$router.push('/enrollment')
    },
    updateLastOperatedDate() {
      this.$store.commit('enrollment/setLastOperatedDate', { lastOperatedDate: new Date })
    },
    returnTop() {
      this.$store.commit('enrollment/initialize', {})
      this.$router.push('/enrollment')
    }
  }
}
